import { useContext, useEffect } from "react"
import { motion } from "framer-motion"
import { ModalContext } from "../contexts/ModalContext"
import { BaseModalType } from "../types"
import { ReactComponent as CLOSE } from "../../assets/CloseICON.svg"

export default function BaseModal({ title, children, bottomRow, modalId, size, big, onClose, onOpen }: BaseModalType) {
    const modalCon = useContext(ModalContext)

    useEffect(() => {
        if (modalCon?.modalId === modalId && modalCon?.open) {
            onOpen?.()
        }
    }, [modalCon?.modalId, modalId, modalCon?.open, onOpen])

    return (
        <div
            // Whole Modal Container
            className={`absolute top-0 left-0 w-screen h-screen overflow-hidden z-50 ${
                modalCon?.modalId === modalId && modalCon?.open ? "" : "hidden"
            }`}>
            {/* Black Shadow Background */}
            <motion.div
                initial={{
                    opacity: 0,
                }}
                animate={{
                    opacity: modalCon?.animation ? 1 : 0,
                }}
                transition={{
                    duration: 0.2,
                    type: "ease",
                }}
                className="w-full bg-black/30 h-full z-50"
                onClick={() => {
                    if (onClose) {
                        onClose()
                    }
                    modalCon?.trigger(0)
                }}
            />
            <motion.div
                initial={{
                    scale: 0,
                }}
                animate={{
                    scale: modalCon?.animation ? 1 : 0,
                }}
                transition={{
                    duration: 0.2,
                    type: "ease",
                }}
                className={`${
                    size && !big
                        ? "w-screen h-screen md:w-fit md:h-fit pt-12 overflow-hidden md:max-h-[90%] pl-4 pr-2"
                        : !size && !big
                        ? "w-full max-w-screen-lg grow h-screen md:max-h-[48rem]"
                        : "w-[90%] h-[90%] min-h-fit min-w-fit"
                } z-50 md:rounded-default bg-white shadow-lg absolute top-0 bottom-0 left-0 right-0 m-auto py-8 pl-2 md:pl-8 md:pr-7 flex flex-col`}>
                <CLOSE
                    className="md:w-6 w-8 md:h-6 h-8 absolute top-4 right-4 cursor-pointer"
                    onClick={() => {
                        if (onClose) {
                            onClose()
                        }
                        modalCon?.trigger(0)
                    }}
                />
                <h1 className="w-full border-b pl-2 pt-4 md:pt-2 text-xl pb-2 font-semibold uppercase">{title}</h1>
                <div className="grow w-full overflow-x-hidden overflow-y-scroll">{children}</div>
                {bottomRow && <div className="w-full border-t pt-2 mt-2">{bottomRow}</div>}
            </motion.div>
        </div>
    )
}
